<template>
  <nav class="main-navbar">
    <div class="nav-wrapper">
      <router-link
        to="/Dashboard"
        active-class="active"
        class="bn-item"
        aria-label="Route to homepage and user dashboard"
      >
        <font-awesome-icon :icon="['fas', 'house']" class="bn-icon" />
        <div class="bn-dot"></div>
      </router-link>
      <router-link
        to="/Transactions"
        active-class="active"
        class="bn-item"
        aria-label="Route to user transactions defaulting at current month"
      >
        <font-awesome-icon :icon="['fas', 'list']" class="bn-icon" />
        <div class="bn-dot"></div>
      </router-link>
      <router-link
        to="/Categories"
        active-class="active"
        class="bn-item"
        aria-label="Route to user defined categories page"
      >
        <font-awesome-icon :icon="['fas', 'tag']" class="bn-icon" />
        <div class="bn-dot"></div>
      </router-link>
      <router-link
        to="/Budget"
        active-class="active"
        class="bn-item"
        aria-label="Route to user budget page defaulting at current month"
      >
        <font-awesome-icon
          :icon="['fas', 'file-invoice-dollar']"
          class="bn-icon"
        />
        <div class="bn-dot"></div>
      </router-link>
      <router-link
        to="/NetWorth"
        active-class="active"
        class="bn-item"
        aria-label="Route to net worth page for financial health overview"
      >
        <font-awesome-icon
          :icon="['fas', 'money-bill-trend-up']"
          class="bn-icon"
        />
        <div class="bn-dot"></div>
      </router-link>
      <router-link
        to="/UserAccount"
        active-class="active"
        class="bn-item"
        aria-label="Route to user page for settings and app info"
      >
        <font-awesome-icon :icon="['fas', 'user']" class="bn-icon" />
        <div class="bn-dot"></div>
      </router-link>
    </div>
  </nav>
</template>

<style scoped>
.main-navbar {
  height: 100%;
}

.nav-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  height: 100%;
  background: #004751;
  position: relative;
  overflow: hidden;
  box-shadow: 0 -4px 24px rgba(0, 71, 81, 0.3);
}

/* Nav items */
.bn-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1;
  text-decoration: none;
  padding: 0.5rem 0;
  position: relative;
  z-index: 1;
  transition: all 0.2s ease;
}

/* Gradient top border via pseudo element — CSS gradients can't be used on border-color */
.bn-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 15%;
  right: 15%;
  height: 2.5px;
  background: transparent;
  border-radius: 0 0 3px 3px;
  transition: background 0.2s ease;
}
.bn-item.active::before {
  background: linear-gradient(90deg, #7f77dd, #5dcaa5);
}

/* Icon */
.bn-icon {
  color: rgba(255, 255, 255, 0.4);
  font-size: 1.1rem;
  transition: color 0.2s ease;
}
.bn-item.active .bn-icon {
  color: #48ffcd;
}
.bn-item:hover .bn-icon {
  color: rgba(255, 255, 255, 0.7);
}

/* Dot indicator */
.bn-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: transparent;
  transition: background 0.2s ease;
}
.bn-item.active .bn-dot {
  background: #48ffcd;
}
</style>

<!-- <template>
  <nav class="main-navbar">
    <div class="nav-wrapper">
      <router-link
        to="/Dashboard"
        active-class="active"
        class="router-styles"
        aria-label="Route to homepage and user dashboard"
        ><font-awesome-icon :icon="['fas', 'house']"
      /></router-link>
      <router-link
        to="/Transactions"
        active-class="active"
        class="flex justify-center align-center"
        aria-label="Route to user transactions defaulting at current month"
        ><font-awesome-icon :icon="['fas', 'list']"
      /></router-link>
      <router-link
        to="/Categories"
        active-class="active"
        class="flex justify-center align-center"
        aria-label="Route to user defined categories page"
        ><font-awesome-icon :icon="['fas', 'tag']"
      /></router-link>
      <router-link
        to="/Budget"
        active-class="active"
        class="flex justify-center align-center"
        aria-label="Route to user budget page defaulting at current month"
        ><font-awesome-icon :icon="['fas', 'file-invoice-dollar']"
      /></router-link>
      <router-link
        to="/NetWorth"
        active-class="active"
        class="flex justify-center align-center"
        aria-label="Route to net worth page for financial health overview"
        ><font-awesome-icon :icon="['fas', 'money-bill-trend-up']"
      /></router-link>
      <router-link
        to="/UserAccount"
        active-class="active"
        class="flex justify-center align-center"
        aria-label="Route to user page for settings and app info"
        ><font-awesome-icon :icon="['fas', 'user']"
      /></router-link>
    </div>
  </nav>
</template>

<style>
.nav-wrapper {
  display: flex;
  justify-content: space-around;
  height: 100%;
}

.light-theme .nav-wrapper {
  background: #004751;
}

.dark-theme .nav-wrapper {
  background: #004751;
}

.main-navbar ul {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 0;
  margin: 0;
}

.main-navbar li {
  flex-grow: 1;
  height: 100%;
  margin: 0;
}

.main-navbar a {
  text-decoration: none;
  font-weight: bold;
  width: 100%;
}

.light-theme .main-navbar a {
  color: #ffffff;
  font-size: 1em;
}

.light-theme .main-navbar .active {
  border-top: 2px solid #0a52d8;
}

.dark-theme .main-navbar .active {
  border-top: 2px solid #48ffcd;
}

.router-styles {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (min-width: 900px) {
  .main-navbar ul {
    display: block;
  }
}
</style> -->
